import React, { Component } from 'react';
import Modal from "react-responsive-modal";
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import {ToastsStore} from 'react-toasts';

import Datepicker from "./datepicker"; 
import Dropzone from "./dropzone";
import { getlanguagelist } from "../../helpers/changelanguage";
import iconPath from "../../helpers/iconHelper";
import { createPolling } from '../../actions/pollingAction';
import {fetchFeedRequest} from "../../actions/feedAction";
import { loader } from '../../actions/utils';
import './polling.css';

const customStyles = {
    width: '556px',
    position: 'relative',
};

class CreatePolling extends Component {
    constructor(props) {
        super(props);
       
        this.state = {
            open         : false,
            active_row   : 2,
            row_1        : '',
            row_2        : '',
            row_3        : 'none',
            row_4        : 'none',
            row_5        : 'none',
            row_6        : 'none',
            expire_date  : new Date(Date.now() + ( 3600 * 1000 * 24)),
            question     : '',
            option1              : '',
            option1_image        : '',
            option1_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
            option2              : '',
            option2_image        : '',
            option2_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
            option3              : '',
            option3_image        : '',
            option3_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
            option4              : '',
            option4_image        : '',
            option4_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
            option5              : '',
            option5_image        : '',
            option5_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
            option6              : '',
            option6_image        : '',  
            option6_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
        };
        this.onOpenModal  = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.appendData   = this.appendData.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.changeFile   = this.changeFile.bind(this);
        this.removeImage  = this.removeImage.bind(this);
        this.onSubmit     = this.onSubmit.bind(this);
        this.removeRow    = this.removeRow.bind(this);
        
    };

    componentDidMount(){
        
    }

    onOpenModal() {
        this.setState({open: true});
    };

    onCloseModal() {
        this.setState({ open : false});
    };

    onDateChange(date){
        this.setState({ expire_date : date })
    }

    appendData() {
       if(this.state.active_row < 6){
           this.setState({
                [`row_${this.state.active_row +1}`]  : 'block',
                active_row                           : this.state.active_row + 1
           });
       }
       
    }
    
    handleChange(e) {
        if((e.target.name == 'question') && (e.target.value.length <= 100)){
            this.setState({
                [e.target.name]: e.target.value,
            });
        }else if(((e.target.name == 'option1') || (e.target.name == 'option2') || (e.target.name == 'option3') || (e.target.name == 'option4') || (e.target.name == 'option5') || (e.target.name == 'option6')) && (e.target.value.length <= 40)){
            this.setState({
                [e.target.name]: e.target.value,
            });
        }
        
    }

    changeFile(index,e){
        let file = e;
        let reader = new FileReader();
        let url = reader.readAsDataURL(file);
        reader.onloadend = function (e) {
           this.fileUpload(reader.result,index);  
        }.bind(this);
    }

    fileUpload(file,index){
       
        let uploadResponse  = [];
        let uploadPathImage = `uploads/${this.props.currentUserDetails.user.id}/poll_image_path`;
        let formData = new FormData();

        formData.append("api_key",'285759666786543');
        formData.append("file", file);
        formData.append("folder", uploadPathImage);
        formData.append("upload_preset", 'lgo8izk7');
        
         let obj = this;
         axios.post('https://api.cloudinary.com/v1_1/www-baaldahab-com/upload/', formData, {
            headers: { "X-Requested-With": "XMLHttpRequest" },
          }).then(function (response) {
            obj.setState({
                [`option${index}_image`]          : response.data.public_id,
                [`option${index}_imagepreview`]   : file
            });
                
          })
       
    } 

    removeImage(index){

        this.setState({
            [`option${index}_image`] : '',
            [`option${index}_imagepreview`] : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png' 
        });
    }

    removeRow(index){
        this.setState({
            [`row_${index}`] : 'none',
            active_row       : this.state.active_row - 1,
            [`option${index}`] : '',
            [`option${index}_image`] : '',
            [`option${index}_imagepreview`] : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png' 
        });
    }

    onSubmit(){
       
        let answer = [];
        localStorage.setItem("new_polling", 'start');
        for(let i = 1; i<= this.state.active_row; i++){
            var row = `row_${i}`;
            var img = `option${i}_image`;
            var opt = `option${i}`;
            
            if(this.state[row] != 'none'){
                let obj = { 'answer_media' : this.state[img],
                            'answer_text'  : this.state[opt]
                          };
                answer.push({'answer_media':this.state[img],'answer_text':this.state[opt]});
               
            }
        }
        let param = {
            expire_date : (moment(this.state.expire_date).format('YYYY-MM-DD')),//'2020-08-20',//this.state.expire_date,
            question    : this.state.question,
            answer      : JSON.stringify(answer)
        }

        if((this.state.option1 != '') && (this.state.option2 != '') && (this.state.question != '')){

            const pollloader = (document.getElementById('pollloader'));
            if(pollloader != null){
                document.getElementById('pollloader').style.display = 'block';
            }

            this.props.createPolling(param);
        }else{
            if(this.state.question == ''){
                ToastsStore.error('Question cannot be blank');
            }else if(this.state.option1 == ''){
                ToastsStore.error('First Option cannot be blank');
            }else if(this.state.option2 == ''){
                ToastsStore.error('Second Option cannot be blank')
            }
        }
        
    }

    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
       // console.log(nextProps.createpolling, this.props.createpolling);
        if(nextProps.createpolling != this.props.createpolling){
           
        }

        if(nextProps.listOfFeed != this.props.listOfFeed){
            this.setState({
                open : false,
                row_1        : '',
                row_2        : '',
                row_3        : 'none',
                row_4        : 'none',
                row_5        : 'none',
                row_6        : 'none',
                expire_date  : new Date(Date.now() + ( 3600 * 1000 * 24)),
                question     : '',
                option1              : '',
                option1_image        : '',
                option1_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
                option2              : '',
                option2_image        : '',
                option2_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
                option3              : '',
                option3_image        : '',
                option3_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
                option4              : '',
                option4_image        : '',
                option4_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
                option5              : '',
                option5_image        : '',
                option5_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
                option6              : '',
                option6_image        : '',  
                option6_imagepreview : (localStorage.getItem('userLanguage')  == 'en') ? 'assets/images/polling-no-image.png' : 'assets/images/polling-no-image-so.png',
            })
            const pollloader = (document.getElementById('pollloader'));
            if(pollloader != null){
                
                document.getElementById('pollloader').style.display = 'none';
               
            }
           
        }
    }
    
    render() {
        let languagelist = getlanguagelist();
        return (
            <div >
               
                                
                <div className="fixed-action-btn2"> 
                    <a href={void(0)} onClick={this.onOpenModal} className="btn-floating btn-lg"> 
                        <img src="/assets/images/polling_add.png" width="30" height="30"/> 
                    </a> 
                </div>

                <div id="polling-div">
                    <Modal open={this.state.open} onClose={this.onCloseModal} showCloseIcon={false} center >
                    
                    <form id="createpolling-form" onSubmit={this.onSubmit}>
                        <div className="modal-header2">
                            <button type="button" className="close" onClick={this.onCloseModal} ><img src="/assets/images/close_btn.png"/></button>
                            {
                            (this.props.currentUserDetails.user.image != '') ? 
                            <img className={(this.props.currentUserDetails.user.membership == 'GOLD') ? "post_user gold_user" : "post_user"} src={this.props.currentUserDetails.user.image} onError = {(e) => {
                                e.target.src = iconPath['DEFAULTUSER'] 
                            }}/> : 
                            <img className="post_user" src={iconPath['DEFAULTUSER']}/>
                            }
                            <h4 className="modal-title">{this.props.currentUserDetails.user.full_name}</h4>
                        </div>
                        <div className="modal-body" style={customStyles}>


                            <div className="expiry-date">
                            
                                <span>
                                    {languagelist.poll1}:  
                                </span>
                                <Datepicker defaultDate={this.state.expire_date} onDateChange={this.onDateChange} />
                            </div>

                            <div className="polling-qstn">
                            
                                <textarea
                                    className  = "modal-textarea polling-textarea"
                                    placeholder=  {languagelist.poll4}
                                    name       = "question" 
                                    onChange   = {this.handleChange} 
                                    value      = {this.state.question} 
                                ></textarea>
                                <span>(100  {languagelist.poll2})</span>
                            </div>

                            <div className="polling-option">
                                <label>{languagelist.poll3} <span>(40 {languagelist.poll2})</span></label>

                                <div id="row_1" style={{display:this.state.row_1}}>
                                    <textarea placeholder={languagelist.poll5} 
                                    name       = "option1" 
                                    onChange   = {this.handleChange} 
                                    value      = {this.state.option1} 
                                    ></textarea>
                                    <div className="row">
                                        <div className="col-lg-8 dropzone-file">
                                            <Dropzone fileIndex={1} changeFile={this.changeFile}/>
                                        </div>
                                        <div className="col-lg-4 no-padding-left">
                                            <div className="polling-preview">
                                                <img className="polling-preview-img" src={this.state.option1_imagepreview} />
                                                {
                                                    (this.state.option1_image != '') ? 
                                                        <a className="polling-preview-close-btn" onClick={()=>this.removeImage(1)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                                    : null
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="row_2" style={{display:this.state.row_2}}>
                                    <textarea  placeholder={languagelist.poll5}
                                                name       = "option2" 
                                                onChange   = {this.handleChange} 
                                                value      = {this.state.option2} 
                                    ></textarea>
                                    <div className="row">
                                        <div className="col-lg-8 dropzone-file">
                                            <Dropzone fileIndex={2} changeFile={this.changeFile}/>
                                        </div>
                                        <div className="col-lg-4 no-padding-left">
                                            <div className="polling-preview">
                                                <img className="polling-preview-img" src={this.state.option2_imagepreview} />
                                                {
                                                    (this.state.option2_image != '') ? 
                                                        <a className="polling-preview-close-btn" onClick={()=>this.removeImage(2)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="row_3" style={{display:this.state.row_3}}>
                                    <textarea placeholder={languagelist.poll5}
                                                name       = "option3" 
                                                onChange   = {this.handleChange} 
                                                value      = {this.state.option3} 
                                    ></textarea>
                                    <a className="polling-option-close-btn" onClick={()=>this.removeRow(3)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                    <div className="row">
                                        <div className="col-lg-8 dropzone-file">
                                            <Dropzone fileIndex={3} changeFile={this.changeFile}/>
                                        </div>
                                        <div className="col-lg-4 no-padding-left">
                                            <div className="polling-preview">
                                                <img className="polling-preview-img" src={this.state.option3_imagepreview} />
                                                {
                                                    (this.state.option3_image != '') ? 
                                                        <a className="polling-preview-close-btn" onClick={()=>this.removeImage(3)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="row_4" style={{display:this.state.row_4}}>
                                    <textarea  placeholder={languagelist.poll5}
                                                name       = "option4" 
                                                onChange   = {this.handleChange} 
                                                value      = {this.state.option4} 
                                    ></textarea>
                                    <a className="polling-option-close-btn" onClick={()=>this.removeRow(4)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                    <div className="row">
                                        <div className="col-lg-8 dropzone-file">
                                            <Dropzone fileIndex={4} changeFile={this.changeFile}/>
                                        </div>
                                        <div className="col-lg-4 no-padding-left">
                                            <div className="polling-preview">
                                                <img className="polling-preview-img" src={this.state.option4_imagepreview} />
                                                {
                                                    (this.state.option4_image != '') ? 
                                                        <a className="polling-preview-close-btn" onClick={()=>this.removeImage(4)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="row_5" style={{display:this.state.row_5}}>
                                    <textarea  placeholder={languagelist.poll5}
                                                name       = "option5" 
                                                onChange   = {this.handleChange} 
                                                value      = {this.state.option5} 
                                    ></textarea>
                                    <a className="polling-option-close-btn" onClick={()=>this.removeRow(5)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                    <div className="row">
                                        <div className="col-lg-8 dropzone-file">
                                            <Dropzone fileIndex={5} changeFile={this.changeFile}/>
                                        </div>
                                        <div className="col-lg-4 no-padding-left">
                                            <div className="polling-preview">
                                                <img className="polling-preview-img" src={this.state.option5_imagepreview} />
                                                {
                                                    (this.state.option5_image != '') ? 
                                                    <a className="polling-preview-close-btn" onClick={()=>this.removeImage(5)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="row_6" style={{display:this.state.row_6}}>
                                    <textarea  placeholder={languagelist.poll5}
                                                name       = "option6" 
                                                onChange   = {this.handleChange} 
                                                value      = {this.state.option6} 
                                    ></textarea>
                                    <a className="polling-option-close-btn" onClick={()=>this.removeRow(6)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                    
                                    <div className="row">
                                        <div className="col-lg-8 dropzone-file">
                                            <Dropzone fileIndex={6} changeFile={this.changeFile}/>
                                        </div>
                                        <div className="col-lg-4 no-padding-left">
                                            <div className="polling-preview">
                                                <img className="polling-preview-img" src={this.state.option6_imagepreview} />
                                                {
                                                    (this.state.option6_image != '') ? 
                                                        <a className="polling-preview-close-btn" onClick={()=>this.removeImage(6)}><img src="assets/images/polling-preview-close-icon.png" /></a>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            
                            </div>
                            {
                                (this.state.active_row < 6) ? 
                                    <div className="polling-addmore">
                                        <a onClick={this.appendData}> + {languagelist.poll8} </a>
                                    </div>
                                : null
                            }
                            

                            <div className="polling-publish-btn">
                                <input type="button" className="btn_5" value={languagelist.poll9} onClick={this.onSubmit}/>
                            </div>
                        </div>
                        
                        <div id="pollloader">
                            <div className="preloaderIcon" >
                                <img style={{height : '200px'}} src="/assets/images/loader_four_somali.gif"  />
                            </div>
                        </div>
                    </form>

                    </Modal>
                 </div>
                 
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentUserDetails : state.login, 
        createpolling      : state.newpoll.newPoll,
        listOfFeed         : state.listfeed, 
    }
}

const mapDispatchToProps = dispatch => {
    return {
      createPolling      : bindActionCreators(createPolling, dispatch),
      fetchFeedRequest  : bindActionCreators(fetchFeedRequest, dispatch),
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(CreatePolling));
